enum DataAttributes {
  DATA_APPEND = 'data-append',
  DATA_PREPEND = 'data-prepend',
  DATA_TO = 'data-to',
}

interface CountToPropsInterface {
  duration?: number;
  decimals?: number;
  onUpdate?: (element: HTMLElement) => void;
  onComplete?: (element: HTMLElement) => void;
  formatter?: (value: number) => string;
}

interface CountToInterface extends CountToPropsInterface {
  duration: number;
  decimals: number;
  onUpdate: (element: HTMLElement) => void;
  onComplete: (element: HTMLElement) => void;
  formatter: (value: number) => string;

  elements?: NodeListOf<Element>;
  defaultFormatter: (value: number) => void;
  process: () => void;
}

export class CountTo implements CountToInterface {
  elements?: NodeListOf<Element>;
  decimals = 0;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onUpdate = (_element: HTMLElement): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onComplete = (_element: HTMLElement): void => {};
  // eslint-disable-next-line @typescript-eslint/unbound-method
  formatter = this.defaultFormatter;
  duration = 3000;

  constructor(elementsSelector: string, props?: CountToPropsInterface) {
    this.elements = document.querySelectorAll(elementsSelector);

    if (props) {
      Object.assign(this, props);
    }
  }

  defaultFormatter(value: number): string {
    return value.toFixed(this.decimals);
  }

  process(): void {
    if (!this.elements) {
      return;
    }

    this.elements.forEach(element => {
      const valueNode: HTMLElement | null = element.querySelector('strong');
      if (!valueNode) {
        return;
      }

      const dataFrom = Number(valueNode.innerHTML);
      const dataTo = Number(valueNode.getAttribute(DataAttributes.DATA_TO));
      const prependText: string | null = valueNode.getAttribute(DataAttributes.DATA_PREPEND);
      const appendText: string | null = valueNode.getAttribute(DataAttributes.DATA_APPEND);

      if (valueNode instanceof HTMLElement) {
        this.animateValue(valueNode, dataFrom, dataTo, prependText, appendText);
      }
    });
  }

  private animateValue(element: HTMLElement, valueFrom: number, valueTo: number, prependText: string | null, appendText: string | null): void {
    let startTimestamp: number;

    const step: FrameRequestCallback = (timestamp) => {
      if (!startTimestamp) {
        startTimestamp = timestamp;
      }

      const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);

      /* Call progress events */
      if (progress >= 1) {
        this.onComplete(element);
      } else {
        this.onUpdate(element);
      }

      element.innerHTML = [
        prependText,
        this.formatter(progress * (valueTo - valueFrom) + valueFrom),
        appendText
      ].join('');

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }
}
